import { useState } from "react";
import styles from "./Calendar.module.scss";

const days = [
  "poniedziałek",
  "wtorek",
  "środa",
  "czwartek",
  "piątek",
  "sobota",
  "niedziela",
];

const shortDays = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nd"];

export default function Calendar({ calendarDate, changeDay, events }) {
  const [activeDay, setActiveDay] = useState("");

  const getDayName = (date) => {
    return new Date(date).toLocaleString("pl-PL", { weekday: "long" });
  };

  const getDaysOfMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  let calendarDays = [];
  let emptyDays = [];

  const initCalendar = (year, month) => {
    const numberOfDays = getDaysOfMonth(year, month + 1);

    for (let i = 1; i <= numberOfDays; i++) {
      const obj = {
        dayOfWeek: days.indexOf(getDayName(`${month + 1}/${i}/${year}`)),
        dayNumber: i,
        dayName: getDayName(`${month + 1}/${i}/${year}`),
        date: `${i}-${month + 1}-${year}`,
        isEvent:
          events !== null
            ? events.find(
                (x) =>
                  x.date ===
                  `${year}-${month >= 9 ? month + 1 : "0" + (month + 1)}-${
                    i >= 9 ? i : "0" + i
                  } 00:00:00`
              ) !== undefined
              ? true
              : false
            : false,
      };

      if (i === 1) {
        for (
          let a = 1;
          a <= days.indexOf(getDayName(`${month + 1}/${i}/${year}`));
          a++
        ) {
          const numberOfDays = getDaysOfMonth(year, month);

          const obj = {
            emptyDay: true,
            dayNumber: numberOfDays - a + 1,
          };

          emptyDays.push(obj);
        }
      }

      calendarDays.push(obj);
      emptyDays.sort(
        (a, b) => parseFloat(a.dayNumber) - parseFloat(b.dayNumber)
      );
    }
  };

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();
  const currentDateFormat = `${currentDay}-${currentMonth + 1}-${currentYear}`;

  const year =
    Object.keys(calendarDate).length > 0
      ? calendarDate.$y
      : calendarDate.getFullYear();

  const month =
    Object.keys(calendarDate).length > 0
      ? calendarDate.$M
      : calendarDate.getMonth();

  initCalendar(year, month);

  const handleClick = (date) => {
    changeDay(date);

    const splitDate = date.split("-");
    setActiveDay(`${splitDate[0]}-${splitDate[1]}-${splitDate[2]}`);
  };

  return (
    <div className={styles.calendarWrapper}>
      <div className={styles.calendar}>
        <div className={styles.calendarWeekdays}>
          {shortDays.map((item, i) => {
            return <p key={i}>{item}</p>;
          })}
        </div>
        <div className={styles.calendarDays}>
          {emptyDays.map((item, i) => {
            return (
              <div className={styles.calendarDayEmpty} key={i}>
                <p className={styles.calendarDayNumber}>{item.dayNumber}</p>
              </div>
            );
          })}
          {calendarDays.map((item, i) => {
            return (
              <div
                className={
                  currentDateFormat === item.date
                    ? `${styles.calendarDay} ${styles.calendarDayToday}`
                    : item.date === activeDay
                    ? `${styles.calendarDay} ${styles.calendarDayActive}`
                    : styles.calendarDay
                }
                key={i}
                onClick={() => handleClick(item.date)}
              >
                <p className={styles.calendarDayNumber}>
                  {item.dayNumber}
                  {item.isEvent && (
                    <span className={styles.calendarDayEvent}></span>
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
